import { getUserState } from '@carvana/core-auth';

const getCookie = (name: string) => {
  const regexp = new RegExp(`(?:^${name}|; *${name})=(.*?)(?:;|$)`, 'g');
  const result = regexp.exec(document.cookie);
  return result === null ? null : result[1];
};

const setCookieForSeconds = (name: string, value: string, seconds: number) => {
  const date = new Date();
  date.setTime(date.getTime() + seconds * 1000);
  const expires = `; expires=${date.toUTCString()}`;

  document.cookie = `${name}=${value}${expires}; path=/`;
};

const setCookie = (name: string, value: string, days: number) => {
  if (days) {
    const daysInSeconds = days * 24 * 60 * 60;
    setCookieForSeconds(name, value, daysInSeconds);
  } else {
    document.cookie = `${name}=${value}; path=/`;
  }
};

const deleteCookie = (name: string) => setCookie(name, '', -1);

const getUserId = () => getUserState().user.user_id;

const getBcId = () => getCookie('BrowserCookieId');

export default {
  deleteCookie,
  getBcId,
  getCookie,
  getUserId,
  setCookie,
  setCookieForSeconds
};
